import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
import { underscore } from '@ember/string';
export default CatalogObjectSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    subscriptionPlanVariations: {
      embedded: 'always',
      serializedOnFragment: 'subscription_plan_data',
      serializedOnKey: 'subscription_plan_variations'
    },
    items: {
      serialize: 'ids',
      deserialize: 'ids',
      serializedOnFragment: 'subscription_plan_data',
      serializedOnKey: 'eligible_item_ids'
    }
  },
  keyForRelationship(key) {
    const underscored = underscore(key);
    return underscored;
  }
});